import $ from 'jquery';

export default class Carousel {
  constructor() {
    this.$carousel = $('.carousel');
    this.currdeg = 0;
    this.modifyDOM();
    this.addEvents();
  }

  modifyDOM() {
  }

  addEvents() {
    $('.carousel .next').on('click', this.rotate.bind(this));
    $('.carousel .item').on('click', this.rotate.bind(this));
    $('.carousel .prev').on('click', this.rotate.bind(this));
    $('.carousel-pagination').on('click', '.swiper-pagination-bullet', this.rotate.bind(this));
  }

  rotate(e) {
    const $target = $(e.target);
    this.currdeg = $target.data('step') * (-60);

    // Set active pagination
    $('.carousel-pagination').find('.swiper-pagination-bullet').removeClass('swiper-pagination-bullet-active');
    $('.carousel-pagination').find(`[data-step= ${$target.data('step')} ]`).addClass('swiper-pagination-bullet-active');

    // Set active item
    this.$carousel.find('.item').removeClass('active');
    this.$carousel.find(`[data-item= ${$target.data('step')} ]`).addClass('active');

    this.$carousel.css({
      '-webkit-transform': `rotateY(${this.currdeg}deg)`,
      '-moz-transform': `rotateY(${this.currdeg}deg)`,
      'o-transform': `rotateY(${this.currdeg}deg)`,
      transform: `rotateY(${this.currdeg}deg)`,
    });
  }
}
